import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.idp.issuer,
  tokenEndpoint: `${environment.idp.issuer}/oauth2/token`,
  // Exact-match against the Service Provider allow-list; no trailing slash.
  // Targets /login so the callback reaches tryLogin() without crossing authGuard.
  redirectUri: `${globalThis.location.origin}/login`,
  clientId: environment.idp.clientId,
  responseType: 'code',
  scope: 'openid',
  strictDiscoveryDocumentValidation: false,
  disablePKCE: true,
  skipIssuerCheck: true,
};
